import React from "react";
interface IconProps {
    fill: string;
    class?: string;
    className?: string;
    height: number;
}


export const ApplianceIcon = (props: IconProps) => (
    <svg fill={props.fill} className={props.class} viewBox="0 0 535.5 535.5" width={props.height} height={props.height} >
        <g>
            <path d="M482.906,28.688h-21.773c1.635-2.821,2.648-6.062,2.648-9.562s-1.014-6.742-2.648-9.562C457.814,3.873,451.713,0,444.656,0
		H320.344c-7.057,0-13.158,3.873-16.477,9.562c-1.635,2.821-2.648,6.062-2.648,9.562s1.014,6.742,2.648,9.562h-72.244
		c1.645-2.821,2.658-6.062,2.658-9.562s-1.014-6.742-2.649-9.562C228.314,3.873,222.213,0,215.156,0H90.844
		c-7.057,0-13.158,3.873-16.476,9.562c-1.635,2.821-2.649,6.062-2.649,9.562s1.014,6.742,2.649,9.562H52.594
		c-15.816,0-28.688,12.871-28.688,28.688v66.938h487.688V57.375C511.594,41.559,498.723,28.688,482.906,28.688z M114.75,99.211
		c-10.566,0-19.125-8.559-19.125-19.125s8.559-19.125,19.125-19.125s19.125,8.559,19.125,19.125S125.316,99.211,114.75,99.211z
		 M186.469,99.211c-10.566,0-19.125-8.559-19.125-19.125s8.559-19.125,19.125-19.125s19.125,8.559,19.125,19.125
		S197.035,99.211,186.469,99.211z M267.75,99.211c-10.566,0-19.125-8.559-19.125-19.125s8.559-19.125,19.125-19.125
		s19.125,8.559,19.125,19.125S278.316,99.211,267.75,99.211z M344.25,99.211c-10.566,0-19.125-8.559-19.125-19.125
		s8.559-19.125,19.125-19.125s19.125,8.559,19.125,19.125S354.816,99.211,344.25,99.211z M420.75,99.211
		c-10.566,0-19.125-8.559-19.125-19.125s8.559-19.125,19.125-19.125s19.125,8.559,19.125,19.125S431.316,99.211,420.75,99.211z"/>
            <path d="M23.906,506.812c0,15.816,12.871,28.688,28.688,28.688h430.312c15.816,0,28.688-12.871,28.688-28.688V143.438H23.906
		V506.812z M100.406,172.125h325.125c5.278,0,9.562,4.284,9.562,9.562s-4.284,9.562-9.562,9.562H100.406
		c-5.278,0-9.562-4.284-9.562-9.562S95.128,172.125,100.406,172.125z M81.281,248.625c0-15.816,12.871-28.688,28.688-28.688h315.562
		c15.816,0,28.688,12.871,28.688,28.688v200.812c0,15.816-12.871,28.688-28.688,28.688H109.969
		c-15.816,0-28.688-12.871-28.688-28.688V248.625z"/>
            <polygon points="202.859,239.062 100.406,310.666 100.406,343.705 250.136,239.062 	" />
            <polygon points="425.531,459 435.094,459 435.094,449.438 435.094,248.625 435.094,239.062 425.531,239.062 292.67,239.062 
		100.406,373.435 100.406,449.438 100.406,459 109.969,459 	"/>


        </g>

    </svg >
)


// WEBPACK FOOTER //
// ./src/layout/icons/Appliance.tsx